/**
 * Razorpay Checkout helper.
 * - Loads the official Checkout script on demand (idempotent)
 * - Opens the Checkout overlay with provided options
 */
export const RAZORPAY_SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

let _scriptPromise = null;

export const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = RAZORPAY_SCRIPT;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => {
      _scriptPromise = null;
      reject(new Error("Failed to load Razorpay Checkout"));
    };
    document.body.appendChild(s);
  });
  return _scriptPromise;
};

/**
 * Open Razorpay checkout. Returns a promise that resolves with the
 * { razorpay_payment_id, razorpay_order_id, razorpay_signature } on success
 * and rejects on dismiss/cancel.
 */
export const openCheckout = async ({
  key_id,
  amount,
  currency = "INR",
  order_id,
  name = "ZaykaQR",
  description = "Subscription payment",
  prefill = {},
  theme = "#F97316",
}) => {
  await loadRazorpay();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: key_id,
      amount,
      currency,
      order_id,
      name,
      description,
      image: undefined,
      prefill,
      theme: { color: theme },
      handler: (resp) => resolve(resp),
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
    });
    rzp.on("payment.failed", (e) => reject(new Error(e?.error?.description || "Payment failed")));
    rzp.open();
  });
};
